<template>
    <div class="guarantee">
        <search-form
            :searcharray="searcharray"
            :span="6"
            @change="search"
            @reset="reset"
            ></search-form>
        <export-excel id="teamTtable" name="到期提醒" size="small" icon="el-icon-download" text="导出表格"></export-excel>
        <el-table :data="tableData" v-loading="loading" element-loading-text="拼命加载中"
            element-loading-spinner="el-icon-loading" style="width: 100%;margin-top:15px" row-key="id" stripe lazy
            size="small" class="teamTtable" id="teamTtable">
            <el-table-column prop="num_id" label="流水号" width="210" fixed="left" v-if="tableTitList.num_id.val"></el-table-column>
            <el-table-column prop="policy_num" label="保单号" width="240" :fixed="fixedlist.includes('policy_num')"
                v-if="tableTitList.policy_num.val">
                <template #header>
                    <span>保单号</span>
                    <span @click="fixed('policy_num')" class="fixedIcon"
                        :class="{ activate: fixedlist.includes('policy_num') }">
                        <i class="iconfont icon-guding"></i>
                    </span>
                </template>
            </el-table-column>
            <el-table-column prop="dqtx" label="到期时间" width="160"></el-table-column>
            <el-table-column prop="applicationName" min-width="200" label="投保人名称" show-overflow-tooltip
                :fixed="fixedlist.includes('applicationName')" v-if="tableTitList.applicationName.val">
                <template #header>
                    <span>投保人名称</span>
                    <span @click="fixed('applicationName')" class="fixedIcon"
                        :class="{ activate: fixedlist.includes('applicationName') }">
                        <i class="iconfont icon-guding"></i>
                    </span>
                </template>
            </el-table-column>
            <el-table-column prop="insuredName" min-width="200" label="被保人名称" show-overflow-tooltip
                :fixed="fixedlist.includes('insuredName')" v-if="tableTitList.insuredName.val">
                <template #header>
                    <span>被保人名称</span>
                    <span @click="fixed('insuredName')" class="fixedIcon"
                        :class="{ activate: fixedlist.includes('insuredName') }">
                        <i class="iconfont icon-guding"></i>
                    </span>
                </template>
            </el-table-column>
            <el-table-column prop="productName" min-width="260" label="产品名称" show-overflow-tooltip
                :fixed="fixedlist.includes('productName')" v-if="tableTitList.productName.val">
                <template #header>
                    <span>产品名称</span>
                    <span @click="fixed('productName')" class="fixedIcon"
                        :class="{ activate: fixedlist.includes('productName') }">
                        <i class="iconfont icon-guding"></i>
                    </span>
                </template>
            </el-table-column>
            <el-table-column prop="companyName" width="150" label="保险公司" :fixed="fixedlist.includes('companyName')"
                v-if="tableTitList.companyName.val">
                <template #header>
                    <span>保险公司</span>
                    <span @click="fixed('companyName')" class="fixedIcon"
                        :class="{ activate: fixedlist.includes('companyName') }">
                        <i class="iconfont icon-guding"></i>
                    </span>
                </template>
            </el-table-column>
            <el-table-column prop="c_time" label="创建时间" width="180" :fixed="fixedlist.includes('c_time')"
                v-if="tableTitList.c_time.val">
                <template #header>
                    <span>创建时间</span>
                    <span @click="fixed('c_time')" class="fixedIcon" :class="{ activate: fixedlist.includes('c_time') }">
                        <i class="iconfont icon-guding"></i>
                    </span>
                </template>
            </el-table-column>
            <el-table-column prop="s_time" label="生效时间" width="180" :fixed="fixedlist.includes('s_time')"
                v-if="tableTitList.s_time.val">
                <template #header>
                    <span>生效时间</span>
                    <span @click="fixed('s_time')" class="fixedIcon" :class="{ activate: fixedlist.includes('s_time') }">
                        <i class="iconfont icon-guding"></i>
                    </span>
                </template>
            </el-table-column>
            <el-table-column prop="e_time" label="截止时间" width="180" :fixed="fixedlist.includes('e_time')"
                v-if="tableTitList.e_time.val">
                <template #header>
                    <span>截止时间</span>
                    <span @click="fixed('e_time')" class="fixedIcon" :class="{ activate: fixedlist.includes('e_time') }">
                        <i class="iconfont icon-guding"></i>
                    </span>
                </template>
            </el-table-column>
            <el-table-column prop="policy_money" label="保费金额" width="150" :fixed="fixedlist.includes('policy_money')"
                v-if="tableTitList.policy_money.val">
                <template #header>
                    <span>保费金额</span>
                    <span @click="fixed('policy_money')" class="fixedIcon"
                        :class="{ activate: fixedlist.includes('policy_money') }">
                        <i class="iconfont icon-guding"></i>
                    </span>
                </template>
            </el-table-column>
            <el-table-column prop="statusTxt" label="保单状态" width="100" :fixed="fixedlist.includes('statusTxt')"
                v-if="tableTitList.statusTxt.val">
                <template #header>
                    <span>保单状态</span>
                    <span @click="fixed('statusTxt')" class="fixedIcon"
                        :class="{ activate: fixedlist.includes('statusTxt') }">
                        <i class="iconfont icon-guding"></i>
                    </span>
                </template>
            </el-table-column>
            <el-table-column prop="work_cate_title" label="职业类别" width="150" show-overflow-tooltip
                :fixed="fixedlist.includes('work_cate_title')" v-if="tableTitList.work_cate_title.val">
                <template #header>
                    <span>职业类别</span>
                    <span @click="fixed('work_cate_title')" class="fixedIcon"
                        :class="{ activate: fixedlist.includes('work_cate_title') }">
                        <i class="iconfont icon-guding"></i>
                    </span>
                </template>
            </el-table-column>
            <el-table-column label="操作" width="100" fixed="right">
                <template #header>
                    <span>操作</span>
                    <el-dropdown :hide-on-click="false">
                        <span class="el-dropdown-link">
                            <i class="el-icon-s-grid"></i>
                        </span>
                        <el-dropdown-menu slot="dropdown">
                            <el-dropdown-item v-for="(v, i) in tableTitList" :key="i">
                                <el-checkbox v-model="v.val" :label="v.name" @change="tableTitListCheng">
                                </el-checkbox>
                            </el-dropdown-item>
                        </el-dropdown-menu>
                    </el-dropdown>
                </template>
                <template slot-scope="scope">
                    <el-button type="text" size="mini" @click="look(scope.row.num_id, scope.row.productCate)">
                        查看
                    </el-button>
                </template>
            </el-table-column>
        </el-table>
        <el-pagination
            @size-change="sizeChange"
            @current-change="currentChange"
            :page-sizes="pageSizeArray"
            :page-size.sync="pageSize"
            :current-page.sync="page"
            :total="total"
            background
            layout="total, sizes, prev, pager, next, jumper"
            >
            </el-pagination>
    </div>
</template>
<script>
import searchForm from "@/components/common/searchForm";
import exportExcel from "@/components/common/exportExcel";
import { yhOrder } from "../../api/yh";
import { getCompany } from "@/api/public";
export default {
    name: "guarantee",
    data() {
        return {
            routeClass: "",
            searcharray: [
                {
                    label: "保险公司",
                    val: "company_id",
                    type: "select",
                    pla: "请选择保险公司",
                    option: []
                },
                {
                    label: "产品名称",
                    val: "productName",
                    type: "input",
                    pla: "请输入产品名称"
                },
                {
                    label: "到期时间",
                    val: "day",
                    type: "select",
                    pla: "请选择到期时间",
                    option: [
                        { label: "还有7天", val: "7" },
                        { label: "还有6天", val: "6" },
                        { label: "还有5天", val: "5" },
                        { label: "还有4天", val: "4" },
                        { label: "还有3天", val: "3" },
                        { label: "还有2天", val: "2" },
                        { label: "还有1天", val: "1" },
                        { label: "今天到期", val: "0" },
                        { label: "已到期1天", val: "-1" },
                        { label: "已到期2天", val: "-2" },
                        { label: "已到期3天", val: "-3" },
                        { label: "已到期4天", val: "-4" },
                        { label: "已到期5天", val: "-5" },
                        { label: "已到期6天", val: "-6" },
                        { label: "已到期7天", val: "-7" },
                    ]
                },
            ],
            searchData: {},
            loading: false,
            tableData: [],
            // 分页 每页条数
            pageSize: 15,
            // 分页 每页条数可选项
            pageSizeArray: [15, 30, 45, 60],
            // 当前页
            page: 1,
            // 总页数
            total: 0,
            fixedlist: JSON.parse(localStorage.getItem("fixedlist")),
            tableTitList: JSON.parse(localStorage.getItem("tableTitList")),
        };
    },
    components: {
        exportExcel,
        searchForm
    },
    beforeCreate() {
        // 判断是否有本地储存fixedlist
        if (!localStorage.getItem("fixedlist")) {
            localStorage.setItem("fixedlist", JSON.stringify([]));
        }
        //判断是否有本地储存
        if (!localStorage.getItem("tableTitList")) {
            localStorage.setItem(
                "tableTitList",
                JSON.stringify({
                    num_id: {
                        val: true,
                        name: "流水号"
                    },
                    policy_num: {
                        val: true,
                        name: "保单号"
                    },
                    applicationName: {
                        val: true,
                        name: "投保人名称"
                    },
                    insuredName: {
                        val: true,
                        name: "被保人名称"
                    },
                    productName: {
                        val: true,
                        name: "产品名称"
                    },
                    companyName: {
                        val: true,
                        name: "保险公司"
                    },
                    c_time: {
                        val: true,
                        name: "创建时间"
                    },
                    s_time: {
                        val: true,
                        name: "生效时间"
                    },
                    e_time: {
                        val: true,
                        name: "截止时间"
                    },
                    policy_money: {
                        val: true,
                        name: "保费金额"
                    },
                    statusTxt: {
                        val: true,
                        name: "保单状态"
                    },
                    work_cate_title: {
                        val: true,
                        name: "职业类别"
                    }
                })
            );
        }
    },
    mounted() {
        // 获取当前路由等级
        this.routeClass = this.$route.matched.length;
        // 获取保司
        this.getCompany();
        // 获取列表
        this.getOrderList();
    },
    methods: {
        //列表固定
        fixed(e) {
            if (this.fixedlist.includes(e)) {
                this.fixedlist.splice(this.fixedlist.indexOf(e), 1);
            } else {
                this.fixedlist.push(e);
            }
            localStorage.setItem("fixedlist", JSON.stringify(this.fixedlist));
        },
        //展示列
        tableTitListCheng() {
            localStorage.setItem("tableTitList", JSON.stringify(this.tableTitList));
        },
        // 获取列表
        getOrderList() {
            let _data = this.searchData;
            let that = this;
            _data.page = this.page;
            _data.limit = this.pageSize;
            _data.identification = 1;
            that.loading = true;
            yhOrder(_data)
                .then(function (res) {
                    console.log(res);
                    that.loading = false;
                    if (res.code == 1) {
                        that.tableData = res.data.list;
                        that.total = res.data.total;
                    } else {
                        that.$message.error(res.msg);
                    }
                })
                .catch(function (error) {
                    console.log(error);
                });
        },
        // 每页几条
        sizeChange() {
            this.getOrderList();
        },
        // 页码变化
        currentChange() {
            this.getOrderList();
        },
        // 查看
        look(e, type) {
            console.log(type);
            // this.$router.push({
            //   path: "/guarantee/details",
            //   query: { numId: e, type: type }
            // });
            let _url = this.$router.resolve({
                path: "/guarantee/details",
                query: { numId: e, type: type }
            });
            window.open(_url.href, "_blank");
        },
        // 搜索数据
        search(e) {
            this.page = 1;
            this.searchData = e;
            this.getOrderList();
        },
        //搜索重置
        reset(e) {
            this.page = 1;
            this.searchData = {};
            this.getOrderList();
        },
        getCompany() {
            let that = this;
            getCompany()
                .then(function(res) {
                console.log(res);
                if (res.code == 1) {
                    res.data.forEach((item, index) => {
                    let _obj = { label: "", val: "" };
                    _obj.label = item.name;
                    _obj.val = item.id;
                    that.searcharray[0].option.push(_obj);
                    });
                } else {
                    that.$message.error(res.msg);
                }
                })
                .catch(function(error) {
                console.log(error);
                });
        }
    }
};
</script>
<style lang="scss">
.guarantee {
    .el-table {
        th {
            background: #f1f4f8;
        }

        th,
        td {
            font-size: 14px;
            color: rgba(0, 0, 0, 0.85);
        }

        .cell {
            margin-left: 20px;
        }

        .fixedIcon {
            color: #c0c4cc;
            cursor: pointer;
            padding-left: 5px;
            vertical-align: middle;

            i {
                font-size: 14px;
            }
        }

        .fixedIcon.activate {
            color: #409eff57;
        }

        .el-dropdown {
            span {
                padding-left: 10px;

                i {
                    font-size: 14px;
                }
            }
        }
    }
}
</style>
